var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 18.5C3 17.9477 3.44772 17.5 4 17.5H8C8.55228 17.5 9 17.9477 9 18.5C9 19.0523 8.55228 19.5 8 19.5H4C3.44772 19.5 3 19.0523 3 18.5Z",
    fill: "#0052BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3C3.89543 3 3 3.89543 3 5V14C3 15.1046 3.89543 16 5 16H25.5796C27.3631 16 28.2547 13.8421 26.9912 12.5832L21.1779 6.79095C18.7413 4.36317 15.4418 3 12.0022 3H5ZM5 5H12.0022C14.9127 5 17.7045 6.15345 19.7662 8.20772L25.5796 14H5V5Z",
    fill: "#0052BE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5C0 2.23858 2.23858 0 5 0H11.9272C16.2165 0 20.3262 1.72222 23.334 4.78018L29.7034 11.2558C31.1752 12.7521 32 14.7668 32 16.8657V23C32 25.7614 29.7614 28 27 28H3C1.34315 28 0 26.6569 0 25V5ZM5 2C3.34315 2 2 3.34315 2 5V25C2 25.5523 2.44772 26 3 26H27C28.6569 26 30 24.6569 30 23V16.8657C30 15.2915 29.3814 13.7805 28.2776 12.6582L21.9081 6.18265C19.2763 3.50694 15.6803 2 11.9272 2H5Z",
    fill: "#0052BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleDoor);
export default __webpack_public_path__ + "static/media/vehicle-door.7b27b295de934f21d59c886375ad1253.svg";
export { ForwardRef as ReactComponent };